import React from 'react'
import Header from '../../components/Header/index'
import {Title, Description, Links} from './styles.js'

function Projects(){
    return(
        <div>
            <Header/>
            <Title>Projetos</Title>

            <Description>
                <ol>
                    <li>
                        <p>Página pessoal feita com ReactJS</p>
                        <Links><a href="https://github.com/alicehabitzreuter/mywebsite">Clique aqui para acessar o repositório</a></Links>
                        <Links><a href="https://alicehabitzreuter.dev">Clique aqui para acessar o site</a></Links>
                    </li>
                </ol>
            </Description>
        </div>
    )
}

export default Projects;